import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import SuccessCheckMark from '../../../../../assets/icons/successCheckMark';
import {TOrderChangePhonePayload} from '../../../../../redux/crm/crm.type';
import * as css from './SuccessFormStep.css';
import {formatCurrentPhoneDisplay, parsePhoneForOrder, PhoneFormValues} from '../../utils';

type Props = {
    orderData: TOrderChangePhonePayload;
    newPhoneValues: PhoneFormValues;
};

export default function SuccessFormStep({orderData, newPhoneValues}: Props) {
    const {t} = useTranslation('layout');
    const fullName = [orderData.firstName, orderData.lastName].filter(Boolean).join(' ').trim();

    const oldPhoneDisplay = useMemo(() => formatCurrentPhoneDisplay(orderData.phone), [orderData.phone]);

    const newPhoneDisplay = useMemo(() => {
        const phoneForApi = parsePhoneForOrder(newPhoneValues.phone, newPhoneValues.country);
        return formatCurrentPhoneDisplay(phoneForApi || undefined);
    }, [newPhoneValues]);

    return (
        <>
            <css.successPanel data-cy="orderChangePhoneSuccessPanel">
                <SuccessCheckMark size={68} backgroundColor={'var(--primitive-green-400)'} color={'var(--primitive-green-600)'} />
                <css.successTitle>{t('orderChangePhoneSuccessHeading')}</css.successTitle>
                <css.successDetails>
                    {fullName ? <css.successNameLine>{fullName}</css.successNameLine> : null}
                    <css.successDetailLine>
                        {t('orderChangePhoneSuccessDetail', {
                            orderId: orderData.oid,
                            oldPhone: oldPhoneDisplay,
                            newPhone: newPhoneDisplay,
                        })}
                    </css.successDetailLine>
                    <css.successNotifyLine>{t('orderChangePhoneSuccessNotifyBoth')}</css.successNotifyLine>
                </css.successDetails>
            </css.successPanel>
        </>
    );
}
